









import { RestClient } from "@elite/restclient";
import { ISelectListItem } from "@everbright/promotions/lib/models";
import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Prop } from "vue-property-decorator";

@Component
export default class LocaleRadioButtonGroup extends Vue {
    @Inject()
    restClient!: RestClient;

    @Prop({ required: true })
    value!: number | null;

    get internalValue(): number | null {
        return this.value;
    }
    set internalValue(val: number | null) {
        this.$emit("input", val);
    }

    items: ISelectListItem[] | null = null;

    async mounted() {
        const itemsResponse = await this.restClient.getJson<ISelectListItem[]>(
            "/api/Locale"
        );

        if (itemsResponse.status === 200 && itemsResponse.data) {
            this.items = itemsResponse.data;

            if (!this.internalValue) {
                this.internalValue = Number(this.items[0].value);
            }
        }
    }
}
